import {BaseModel} from './base-model';

export class ContextList extends BaseModel {
  object_type = 'ContextList';
  meta_type = 'context_list';
  contexts: Array<BaseModel> = [];
}
